import { useState } from "react";
import ModuleHeader from "../../components/ModuleHeader";
import DepositTab from "./DepositTab";
import ApproverLogTab from "./ApproverLogTab";

const TABS = [
  { key: "pending", label: "Pending Deposits" },
  { key: "approved", label: "Approved Deposits" },
  { key: "rejected", label: "Rejected Deposits" },
  { key: "cod-approver-log", label: "COD Approver Log" },
];

export default function CashCOD() {
  const [activeTab, setActiveTab] = useState("pending");

  const renderContent = () => {
    if (activeTab === "cod-approver-log") {
      return (
        <div style={{ padding: 24 }}>
          <ApproverLogTab />
        </div>
      );
    }

    return (
      <div style={{ padding: 24 }}>
        <DepositTab status={activeTab} />
      </div>
    );
  };

  return (
    <div>
      <ModuleHeader
        title="CASH & COD"
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      {renderContent()}
    </div>
  );
}
